import styled, { css } from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing, borderRadius } from 'stylesheetB2b';

const largeStyle = css`
  width: ${getSpacing(17)};
  height: ${getSpacing(17)};
  font-size: ${getSpacing(16)};
`;

const mediumStyle = css`
  width: ${getSpacing(14)};
  height: ${getSpacing(14)};
  font-size: ${getSpacing(10)};
`;

interface StyledButtonProps {
  large?: boolean;
  colors: ColormapInterface;
  playPlauseButton: boolean;
}

export const StyledButton = styled.button<StyledButtonProps>`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ colors }) => colors.controlBarButtonBackground};
  color: ${({ colors }) => colors.buttonSecondary};
  border-radius: 50%;
  border: none;
  cursor: pointer;
  ${({ large }) => (large ? largeStyle : mediumStyle)}

  &:disabled {
    color: ${({ colors }) => colors.buttonDisabled};
  }
    
  width: ${getSpacing(10)};
  ${({ playPlauseButton, colors }) =>
  playPlauseButton &&
  css`
      /* prettier-ignore */
      & .MuiSvgIcon-root { /* stylelint-disable-line */
        border-radius: ${borderRadius.rounded};
        background-color: ${colors.playPauseBackground};
      }
    `}
`;
StyledButton.displayName = 'StyledButton';

export const ButtonContainer = styled.div`
  :not(:last-child) {
    margin-right: ${getSpacing(2.5)};
  }
`;
ButtonContainer.displayName = 'ButtonContainer';
